export default "__VITE_ASSET__Bm7$d5h9__"